import { map, type OperatorFunction } from 'rxjs';

import { type ApiResponse } from '../types';

import { assertPresent } from '../utils/assert-present';

export function mapDataNonNull<TDto, T = TDto>(
  mapper?: (dto: TDto) => T,
): OperatorFunction<ApiResponse<TDto | null>, T> {
  return map((response) => {
    assertPresent(response.data);
    return mapper ? mapper(response.data) : (response.data as unknown as T);
  });
}
